export function extractTextFromChildren(element: Element): string | undefined {
  if (!element) {
    return;
  }

  const textContent = element.textContent?.trim() || '';

  if (element.children.length === 0) {
    // eslint-disable-next-line consistent-return
    return textContent;
  }

  let innermostText = '';
  for (const child of element.children) {
    innermostText += `${extractTextFromChildren(child)} `;
  }

  // eslint-disable-next-line consistent-return
  return innermostText.trim();
}
